import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone;

const toBytes = (s) => {
  const raw = atob((s + "=".repeat((4 - (s.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

async function subscribe() {
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.key) });
  await api.post("/push/subscribe", sub.toJSON());
}

// state: on | default | denied | ios-install | unsupported | error
export function usePush() {
  const initial = () => {
    if (supported()) return Notification.permission === "granted" ? "on" : Notification.permission;
    return isIos() && !standalone() ? "ios-install" : "unsupported";
  };
  const [state, setState] = useState(initial);

  useEffect(() => {
    if (state === "on") subscribe().catch(() => setState("error"));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const enable = async () => {
    const p = await Notification.requestPermission();
    if (p !== "granted") return setState(p);
    try {
      await subscribe();
      setState("on");
    } catch (_) {
      setState("error");
    }
  };
  return { state, enable };
}
